// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"95f1fb96","642":"bf405cd9"}[chunkId] + ".chunk.js";
};